import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';
import {HttpService} from '../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


export interface DialogData {
  email: string;
  message: string;
}

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent implements OnInit {

  contactForm = this.fb.group({
    name: ['', Validators.required],
    surname: ['', Validators.required],
    company: ['', Validators.required],
    town: [''],
    zipcode: [''],
    email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]],
    phone: [''],
    optin: [false]
  });

  inputContain="name";
  private timeOut;

  constructor( public httpService: HttpService, private fb: FormBuilder,  private router: Router, public dialog: MatDialog) { }

  ngOnInit() {
    this.startTimeOut();
  }


  validContact() {
    //console.log(this.contactForm.value);
    //this.controlContact(this.contactForm.value);
    clearTimeout(this.timeOut);
    this.router.navigate(["home"]);
  }

  get name() { return this.contactForm.get('name'); }
  get town() { return this.contactForm.get('town'); }
  get zipcode() { return this.contactForm.get('zipcode'); }
  get email() { return this.contactForm.get('email'); }
  get phone() { return this.contactForm.get('phone'); }

  getEmailErrorMessage() {
    return this.email.hasError('required') ? 'Vous devez renseigner l\'émail' :
      this.email.hasError('email') ? 'L\'émail semble incorrect' :
        '';
  }

  controlContact(data) {
    if (this.contactExist(data.email)) {
      console.log("Vous avez déjà été enregistré");
      this.openDialogControlContact(data.email);
    } else {
      this.setLocalStorageEmail(data.email);
    }
  }

  contactExist(data: string): boolean {
    var contacts_emails = JSON.parse(localStorage.getItem("contacts_emails"));
    if (contacts_emails!=null) {
      return contacts_emails.includes(data);
    }
    else {
      localStorage.setItem('contacts_emails', '[]');
      return false}
  }

  setLocalStorageEmail(email) {
    var contacts_emails = JSON.parse(localStorage.getItem('contacts_emails'));
    contacts_emails.push(email);
    localStorage.setItem('contacts_emails', JSON.stringify(contacts_emails));
    if (this.contactForm.value.zipcode==null) {this.contactForm.value.zipcode=""}
    if (this.contactForm.value.phone==null) {this.contactForm.value.phone=""}
    this.contactForm.value.optin==true ? this.contactForm.value.optin="oui" : this.contactForm.value.optin="non";
    this.postServices(this.contactForm.value);
  }

  postServices(data) {
    console.log(data);
    this.httpService.postContactForm(data);
    this.httpService.send_email(data);
    this.openDialogEmailSending(data.email);
  }


  openDialogControlContact(email): void {
    const dialogRef = this.dialog.open(DialogOverview, {
      width: '450px',
      data: {
        email: email,
        message: "Cher participant, ce mail est déjà enregistré."}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openDialogEmailSending(email): void {
    const dialogRef = this.dialog.open(DialogOverview, {
      width: '450px',
      data: {
        email: email,
        message: "Cher participant, un émail vous a été envoyé vous permettant de télécharger nos documents."}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      clearTimeout(this.timeOut);
      this.router.navigate(["home"]);
    });
  }

  onInput(event: any) { // without type info
    this.inputContain = event.target.id;
    console.log(this.inputContain);
    this.startTimeOut();
  }

  onTouch(event: any) { // without type info

    var data = event.target.dataset.value;
    console.log(data);
    if (data=="suppr") {
      var initialDataSliced=this.contactForm.get(this.inputContain).value.toString().slice(0, -1);
      console.log(initialDataSliced);
      this.contactForm.controls[this.inputContain].setValue(initialDataSliced);

    }
    else {
      if ( this.inputContain=="zipcode") {
        var reg1 = new RegExp('^[0-9]+$');
        var reg2 = new RegExp('^[0-9]{0,4}$');
        if (reg1.test(data)==true && reg2.test(this.contactForm.get(this.inputContain).value)) {
          var initialData=this.contactForm.get(this.inputContain).value;
          this.contactForm.controls[this.inputContain].setValue(initialData+data);
        }
      }
      else if ( this.inputContain=="phone") {
        var reg1 = new RegExp('^[0-9]+$');
        var reg2 = new RegExp('^[0-9]{0,9}$');
        if (reg1.test(data)==true && reg2.test(this.contactForm.get(this.inputContain).value)) {
          var initialData=this.contactForm.get(this.inputContain).value;
          this.contactForm.controls[this.inputContain].setValue(initialData+data);
        }
      }
      else {
        var initialData=this.contactForm.get(this.inputContain).value;
        this.contactForm.controls[this.inputContain].setValue(initialData+data);
      }
    }
  }

  goHome() {
    clearTimeout(this.timeOut);
    this.router.navigate(["home"]);
  }


  startTimeOut(){
    console.log('startTimeOut');
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(()=>{
      this.router.navigate(['home']);
    }, 180000);
  }
}

@Component({
  selector: 'dialog-overview',
  templateUrl: 'dialog-overview.html',
})
export class DialogOverview {
  constructor(
    public dialogRef: MatDialogRef<DialogOverview>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
